import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import InfoBox from '../components/info-box';
const BuildingNotFound = (props) => (React.createElement(Fragment, null,
    React.createElement(InfoBox, { msg: "We can't find that one anywhere - try the map again?" }),
    React.createElement("div", { className: "buttons-container ml-3 mr-3" },
        React.createElement(Link, { to: `/${props.mode}/categories`, className: "btn btn-secondary" }, "Back to categories"))));
export default BuildingNotFound;
